import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Olemme pahoillamme, ettei artikkeli ollut hyödyllinen. Kerrotko, mikä siinä oli vikana?',
  text: '',
  form: {
    fields: [
      {
        type: 'checkbox',
        name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME,
        items: [
          {
            label: 'Etsimäni tieto puuttuu',
            value: 'missing_information',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Siinä on asiavirheitä',
            value: 'factual_errors',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Jotkut asiat ovat epäselviä',
            value: 'not_clear',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          }
        ]
      },
      {
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Anna meille lisätietoja, niin parannamme tätä artikkelia.',
        type: 'textarea'
      }
    ],
    submit: {
      label: 'Lähetä'
    }
  }
};